module.exports = __webpack_public_path__ + "static/media/user_6.97df01fc.png";